import { render, staticRenderFns } from "./IframePage.vue?vue&type=template&id=7920b0b0&"
import script from "./IframePage.vue?vue&type=script&lang=js&"
export * from "./IframePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports